<template>
  <main class="home-page">
    <HeroSection
      :isAuth="isAuth"
      @openSignIn="openSignIn"
      @openSignUp="openSignUp"
    />
    <ProductCarousel
      :title="$t('Exclusive CS2 Skins Just for You')"
      showArrows="true"
      :chosenItem="chosenItem"
      apiEndpoint="items/list?new=true"
      showAllLink="/products/all"
      @goToProduct="goToProduct"
      @addToCart="addToCart"
    />

    <WhyChooseUs />

    <!-- <section class="section last-sales-section">
      <LastSales :currencySymbol="currencySymbol" @goToProduct="goToProduct" />
    </section> -->

    <!-- <section class="section packs-of-random-section">
      <RandomCasesSlider :currencySymbol="currencySymbol" :currencyCode="currencyCode" @goToProduct="goToProduct" />
    </section> -->

    <StartShoppingSection
      :isAuth="isAuth"
      @openSellSkinModal="openSellSkinModal"
      @openSignIn="openSignIn"
    />

    <!-- <PaymentMethodsSection /> -->
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import ProductCarousel from "@/components/ProductCarousel.vue";
import HeroSection from "@/components/HeroSection.vue";
import WhyChooseUs from "@/components/WhyChooseUs.vue";
import StartShoppingSection from "@/components/StartShoppingSection.vue";
export default {
  name: "HomePage",
  components: {
    ProductCarousel,
    StartShoppingSection,
    WhyChooseUs,
    HeroSection,
  },

  props: {
    chosenItem: {
      type: String,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
    isAuth: {
      type: Boolean,
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      saleProducts: [],
      newArrivals: [],
      activePanels: [],
      faq: [],
    };
  },
  computed: {
    ...mapGetters("app", ["currentLanguage", "currencyCode"]),
  },
  watch: {
    currencyCode() {
      this.getNewArrivals();
      this.getSale();
    },
    lang() {
      this.getFaq();
    },
  },
  async mounted() {
    this.getSale();
    this.getNewArrivals();
    this.getFaq();
  },
  methods: {
    addToCart(item) {
      this.$emit("addToCart", item);
    },
    openSellSkinModal() {
      this.$emit("openSellSkinModal");
    },
    openSignIn() {
      this.$emit("openSignIn");
    },
    openSignUp() {
      this.$emit("openSignUp");
    },
    getFaq() {
      this.$http
        .get(process.env.VUE_APP_API + "faq")
        .then((res) => {
          this.faq = res.data.payload;
        })
        .catch(() => {});
    },
    getNewArrivals() {
      this.$http
        .get(process.env.VUE_APP_API + "items/list?new=true")
        .then((res) => {
          this.newArrivals = res.data.payload;
        })
        .catch(() => {});
    },
    getSale() {
      this.$http
        .get(process.env.VUE_APP_API + "items/list?sale=true")
        .then((res) => {
          this.saleProducts = res.data.payload;
        })
        .catch(() => {});
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
  },
};
</script>

<style scoped lang="scss">
.hero-image {
  -webkit-user-drag: none;
  pointer-events: none;
  user-select: none;

  /* Safari and Chrome */
  -webkit-user-select: none;
  /* Firefox */
  -moz-user-select: none;
  /* Internet Explorer and Microsoft Edge */
  -ms-user-select: none;
  /* Opera */
  -o-user-select: none;
  cursor: default;
}

.hero-top {
  position: absolute;
  top: -14px;
  right: 0;
}
</style>
